import { styled } from '@mui/material';
import { ReactNode } from 'react';

export type BadgeProps = {
  children: ReactNode;
  className?: string;
};

const StyledBadge = styled('div')(({ theme }) => ({
  background: 'var(--background-background-secondary-color)',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  border: '1px solid var(--stroke-stroke-primary-color)',
  color: 'var(--text-text-secondary-color)',
  borderRadius: theme.spacing(5),
  fontWeight: 500,
  fontSize: 12,
}));

export const Badge = ({ children, className }: BadgeProps) => (
  <StyledBadge className={className}>{children}</StyledBadge>
);
